import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { validationFailed, fixServerError } from '../../actions/auth-action';
import { addField, deleteField } from '../../actions/field-action';
import './style.css';


class PasswordField extends Component {
  state = {
    hidePass: true
  };

  onPassHideClick() {
    this.setState({hidePass: !this.state.hidePass});
  }

  onFocus() {
    this.refs.errorMessage.innerHTML = '';
    this.refs.input.classList.remove('field-element__field_error');
  }

  onBlur() {
    this.props.fixServerError({...this.props.serverErrors}, this.props.fieldName);
    this.checkField()
  }

  componentDidMount() {
    if (this.props.validate) {
      this.checkField();
    }
  }

  clearField() {
    if (this.refs.input) {
      this.refs.input.value = '';
    }
  }

  componentWillUnmount() {
    this.props.deleteField(this.props.fieldName);
  }

  checkField() {
    if (this.refs.input != undefined) {
      const fieldName = this.props.fieldName;
      let msg = null;
      if (fieldName in this.props.serverErrors) {
        msg = this.props.serverErrors[fieldName];
      } else {
        msg = this.props.errorHandler(this.refs.input);
      }
      this.refs.errorMessage.innerHTML = msg;
      if (msg != null) {
        this.refs.input.classList.add('field-element__field_error');
        this.props.validationFailed();
      } else {
        this.props.addField(this.props.fieldName, this.refs.input.value);
        this.refs.input.classList.remove('field-element__field_error');
      }
    }
  }

  render() {
    if (this.props.validate) {
      this.checkField();
    }

    if (this.props.clearFields) {
      this.clearField();
    }

    return (
      <div className='field-element'>
        <label className='field-element__label'>{this.props.title}</label>
        <input autoComplete='off' className='field-element__field'
               type={this.state.hidePass ? 'password' : 'text'}
               onFocus={this.onFocus.bind(this)} onBlur={this.onBlur.bind(this)}
               name={this.props.fieldName} ref='input'
        />
        <div className={this.state.hidePass ? 'field-element__field_pass-hidden' : 'field-element__field_pass-show'}
             onClick={this.onPassHideClick.bind(this)} />
        <div ref='errorMessage' className='field-element__error'/>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  validate: state.auth.validate,
  serverErrors: state.auth.serverErrors
});

const mapDispatchToProps = (dispatch) => ({
  validationFailed: bindActionCreators(validationFailed, dispatch),
  fixServerError: bindActionCreators(fixServerError, dispatch),
  addField: bindActionCreators(addField, dispatch),
  deleteField: bindActionCreators(deleteField, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(PasswordField);



// WEBPACK FOOTER //
// ./src/blocks/form-field/PasswordField.js